import { useRef } from 'react';
import { ImagePlus, X } from 'lucide-react';
import { compressImage } from '../lib/model';

export function RepairPhoto({ t, which, photo, onChange }) {
  const ref = useRef(null);
  const pick = async (e) => { const f = e.target.files?.[0]; e.target.value = ''; if (f) onChange(await compressImage(f, 1400, 0.8)); };
  return (
    <div className="rep-photo" data-testid={`maint-repair-photo-${which}`}>
      <small>{t[which === 'before' ? 'mtBefore' : 'mtAfter']}</small>
      {photo ? (
        <span className="rep-thumb"><img src={photo.data} alt="" data-testid={`maint-repair-photo-${which}-img`} /><button className="icon-btn" data-testid={`maint-repair-photo-${which}-remove`} onClick={() => onChange(null)}><X size={12} /></button></span>
      ) : (
        <button className="rep-add" data-testid={`maint-repair-photo-${which}-btn`} onClick={() => ref.current.click()}><ImagePlus size={18} /></button>
      )}
      <input ref={ref} type="file" accept="image/*" hidden data-testid={`maint-repair-photo-${which}-input`} onChange={pick} />
    </div>
  );
}

export const RepairThumbs = ({ t, photos }) => (photos?.before || photos?.after ? (
  <span className="rep-thumbs" data-testid="maint-repair-thumbs">
    {['before', 'after'].map((w) => photos[w] && <a key={w} href={photos[w].data} target="_blank" rel="noreferrer" title={t[w === 'before' ? 'mtBefore' : 'mtAfter']}><img src={photos[w].data} alt="" /><em>{t[w === 'before' ? 'mtBefore' : 'mtAfter']}</em></a>)}
  </span>
) : null);
